module.exports = __webpack_public_path__ + "img/logo.80e0db45.png";